module.exports = __webpack_public_path__ + "img/bg3.2ce1e7ed.png";